import { useState, FormEvent } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import SEOHead from "../../components/feature/SEOHead";
import { useTheme } from "../../contexts/ThemeContext";

const TOPICS = [
  "General Inquiry",
  "Billing & Subscription",
  "Technical Support",
  "Feature Request",
  "Partnership",
  "Press & Media",
];

const CONTACT_CARDS = [
  {
    iconType: "img" as const,
    iconSrc: "data:image/webp;base64,UklGRrgFAABXRUJQVlA4IKwFAAAwIwCdASqtAJQAPnE0lkikoqKhI1Lq6JAOCWlu56ABMbfDPrCdLP4l9r8419p/1P9a4kd4r/Gv8r/N/2q4pMAH5l/XOJ3SKTr38140/pX9i/gD/Vz/l+rr7A/2X9ln9qib8gwreHbbamg2UV+YvRA/wUr1Z++se597T0teJOpFv/Hb/iR+a3LAGtfTCzm1cbOAZ4b99tPX8xQ7Rx2+pt9ZrRdpqnR3r0h23DdwtHTQvDf1R3kZNkliNC5qqvFxYEBuKG2YD8QNkW5fECLqyQZ2lpiJ7RyzD/rSXkd6b7irneJmy3evBly2NQ+uuiGGhoLmJMUzDvPFCujaFYSU59+utVKdyScKyMEWhbQM6CqvdS7/2Px/U9qbeZrwGkGFbw7ZQAD+/EoAEynO7NqEYh0Aobz0FVd+UH1CGa7P+XJlfy5bvU4iDu0Kd+bFPOamUfbClPw+u1FNbPmkvxcDdzH7EkexFHvQX8+dI3vimkUk017NQXcfnClPP2GXSuQQBUM7QXOJ+aYcgJTErh+QfUuoqtIZ96H+AML1GpUdE7+Nhxb3ef2Ms2Co0Or9ezCesfTl9r8xcV80h5N/29/4xfvMWQf+ks+tVBXRhC3K0AXrEi47X2y15BREEQLegljQVJ0MD2WQMgwISRITrawz4GoV7HJVB2ViUeZRhfENyZdbdjnRA+oLfW7f4oBoJSo7P8PqEugVR2NYwOuHXr4ef7E+mOJn81BEMc0d0hkvBiL9Opeg/B2fgA68EFQ0TREIqpXTsfkQ3wEEObCa5v0yWV4299qwYD0ukjYFxUEKS+mAO0mwn9VeGZoevOVbOdJ/E2tniaRcZYzbE6uUq/w5S4n4iWgoJhceYiOi3o8UuZ6hBI/PHHxrsFIKrJe/0N+pzrYWIMja/G7tEPTJvCc13XgjnpqpYTNMgywpmXt/x/V7RxSHENv9fBEQeo8f2V6cNqTIUJfFvsGKL5sTKBbckPQWP5fsqfzyWdV9+p+aD4Ai16F4zbeT89TUsT2nmx7fzxrYsDQAOAow0buKPW5jfZ7jL2dYc1138bdaCXzFYCmw8xJID1gbsbVCfYQ05Ujpf9Wx3QTOqqaeJ397gbBg/2dDNKLZ0nSv8NcSc6e1J+4L5WZxfZneQUc9jyXH722YA3T4TxrgvQtjiknu8uEh4USo+Ey13XV7fCROp0KC2OXtBh4Y8uL20BW50BjKoGGxryu80e0ff0f20NmnnEOqlfgiyk+7ZeYH+VO22S+WsYn0kQzbHtWpKCMCO9fVnmUOvdckP0zmjyankN1e+UnmlIUqO5JsQjR55Rf6aUh5iMJgEa3oWuv/0n5TfYyvQ5VEL7H376oePbuN1cg/0pOQPh8bHUcOS123fFv6vJQZImKRrZAzBkTp+ewrea/a64f0/Ea0q916lzH1MmQHSREpvj7QOdGivEqIyMJxUsDQuxNlYqMWHTDVAO6SwqkHun1XI/zjDctSJ4BBJuq22D9FhQA2BAygfooBSmWTfcKF7nXWmgK4e/PdwWfPZ4lr2XkTj0csYs/DWBJc2ysxRJyTU9hiVCea/BhwVwHSkCO86l+4b2Fu8/ukn/xohb+d//OKjzSGHxIJnDkeYgaO0ed6GeR5yIm6Dy2zJFxPkEP9fJ5ePT4wunXqBu9jkVazpjZyIxmuwz5OO+PZuhlEqLKwpQc0h4yn6Jv/IFHVfJKNBdaNSgW9assAuLhVm8RnelCfW3a+0nWf1MA9OP06vIGwA3lEx5kiAlZen2usV5LtgFEjjvzh2xGdVd884qJVFt398wKnYsdqpi3xVIrWVCTEuWTAAmi/J7oQsn5P+mqvPt1WUkh1//TG7WsnvXD6V2A3t5vxONuoCfMWPDp8qdBSEoXSUb98G++2fVCVmcwl7EDq/Dbyw7O1oJPTAnnj0T37Ur54mLCI4VrgVUAAAAA=",
    title: "Email Us",
    desc: "Best for non-urgent questions. We reply within 24 hours.",
    action: "support@trackly.to",
    href: "mailto://support@trackly.to",
  },
  {
    iconType: "img" as const,
    iconSrc: "https://static.readdy.ai/image/1de166adf1bbf13a9e4054af96cf4ae8/6a89ce6d395012c07171b8e7ef651f2e.png",
    title: "Twitter / X",
    desc: "Reach us publicly or via DM for quick updates.",
    action: "@usetrackly",
    href: "https://x.com/usetrackly",
  },
];

const SITE_URL = import.meta.env.VITE_SITE_URL ?? "https://trackly.app";

const contactJsonLd = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "name": "Contact Trackly — Support, Billing & Enquiries",
  "description": "Reach the Trackly team for support, billing help, feature requests, or general questions. We reply within 24 hours.",
  "url": `${SITE_URL}/contact`,
  "isPartOf": {
    "@type": "WebSite",
    "name": "Trackly",
    "url": SITE_URL,
  },
};

export default function ContactUs() {
  const { isDark } = useTheme();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [topic, setTopic] = useState("");
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const inputClass = `w-full border rounded-xl px-4 py-3 font-inter text-sm focus:outline-none focus:ring-2 transition-all duration-150 ${
    isDark
      ? "bg-white/5 border-white/10 text-white placeholder:text-[#444] focus:ring-white/15 focus:border-white/25"
      : "bg-white border-black/10 text-[#111] placeholder:text-[#aaa] focus:ring-black/8 focus:border-black/25"
  }`;

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !topic || !message.trim()) {
      setError("Please fill in all fields.");
      return;
    }
    if (message.length > 500) {
      setError("Message must be 500 characters or fewer.");
      return;
    }
    setError(null);
    setSubmitting(true);
    try {
      const body = new URLSearchParams();
      body.append("name", name.trim());
      body.append("email", email.trim());
      body.append("topic", topic);
      body.append("message", message.trim());
      await fetch("https://readdy.ai/api/form/d6usri5t4s7j0tv5i930", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={`min-h-screen transition-colors duration-300 ${isDark ? "bg-[#050505]" : "bg-[#f8f8f8]"}`}>
      <SEOHead
        title="Contact Trackly — Get Help, Report Issues & General Enquiries"
        description="Reach the Trackly team for support, billing help, feature requests, or general questions. We respond within 24 hours on every flip-related issue."
        keywords="contact trackly, trackly support, reseller tracker help, billing enquiry"
        canonical={`${SITE_URL}/contact`}
        ogTitle="Contact Trackly — We Reply Within 24 Hours"
        ogDescription="Need help with Trackly? Email us, tweet us, or use the contact form. Fast, friendly support for resellers."
        jsonLd={contactJsonLd}
      />
      <Navbar />

      <main className="pt-36 pb-24 px-8 lg:px-16">
        <div className="max-w-5xl mx-auto">

          {/* Header */}
          <div className="text-center mb-16">
            <span className={`inline-flex items-center gap-2 font-inter text-xs font-medium px-3 py-1.5 rounded-full mb-6 ${isDark ? "bg-white/5 text-[#888]" : "bg-black/6 text-[#666]"}`}>
              <i className="ri-customer-service-2-line text-xs" />
              We&apos;re here to help
            </span>
            <h1 className={`font-syne text-5xl lg:text-6xl font-bold mb-5 leading-tight ${isDark ? "text-white" : "text-[#111111]"}`}>
              Contact Us
            </h1>
            <p className={`font-inter text-base leading-relaxed max-w-md mx-auto ${isDark ? "text-[#555555]" : "text-[#666666]"}`}>
              Got a question, issue, or just want to say hi? Send us a message and we&apos;ll get back to you fast.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

            {/* Left — Contact Cards */}
            <div className="flex flex-col gap-5">
              {CONTACT_CARDS.map((card) => (
                <a
                  key={card.title}
                  href={card.href}
                  rel="nofollow"
                  className={`group rounded-2xl border p-6 flex flex-col gap-4 transition-all duration-200 cursor-pointer ${isDark ? "bg-white/[0.02] border-white/6 hover:border-white/12" : "bg-white border-black/8 hover:border-black/15"}`}
                >
                  <div className="w-14 h-14 flex items-center justify-center">
                    {card.iconType === "img" ? (
                      <img
                        src={(card as { iconType: "img"; iconSrc: string }).iconSrc}
                        alt={card.title}
                        className={`w-11 h-11 object-contain ${isDark ? "invert-0" : "invert"}`}
                      />
                    ) : (
                      <i className={`${(card as { iconType: "ri"; icon: string }).icon} text-4xl ${isDark ? "text-[#aaaaaa]" : "text-[#555555]"}`} />
                    )}
                  </div>
                  <div>
                    <h3 className={`font-syne text-sm font-semibold mb-1 ${isDark ? "text-white" : "text-[#111111]"}`}>
                      {card.title}
                    </h3>
                    <p className={`font-inter text-xs leading-relaxed mb-2 ${isDark ? "text-[#666]" : "text-[#888]"}`}>
                      {card.desc}
                    </p>
                    <span className={`font-inter text-sm font-medium transition-colors duration-200 ${isDark ? "text-[#aaa] group-hover:text-white" : "text-[#444] group-hover:text-[#111]"}`}>
                      {card.action}
                    </span>
                  </div>
                </a>
              ))}

              {/* FAQ nudge */}
              <div className={`rounded-2xl border p-6 ${isDark ? "bg-white/[0.02] border-white/6" : "bg-white border-black/8"}`}>
                <div className="w-14 h-14 flex items-center justify-center mb-4">
                  <img
                    src="https://static.readdy.ai/image/1de166adf1bbf13a9e4054af96cf4ae8/e6aa943e2b2e0a08582bf32ef9bbbf53.jpeg"
                    alt="Billing"
                    className="w-11 h-11 object-contain"
                  />
                </div>
                <h3 className={`font-syne text-sm font-semibold mb-1 ${isDark ? "text-white" : "text-[#111111]"}`}>
                  Have a billing issue?
                </h3>
                <p className={`font-inter text-xs leading-relaxed mb-3 ${isDark ? "text-[#666]" : "text-[#888]"}`}>
                  For subscription and payment queries, select &ldquo;Billing &amp; Subscription&rdquo; in the form topic.
                </p>
                <Link
                  to="/product#pricing"
                  className={`font-inter text-xs font-medium underline underline-offset-2 transition-colors duration-200 ${isDark ? "text-[#aaa] hover:text-white" : "text-[#555] hover:text-[#111]"}`}
                >
                  View pricing &rarr;
                </Link>
              </div>
            </div>

            {/* Right — Form */}
            <div className={`lg:col-span-2 rounded-2xl border p-8 transition-colors duration-300 ${isDark ? "bg-white/[0.02] border-white/6" : "bg-white border-black/8"}`}>
              {submitted ? (
                <div className="flex flex-col items-center justify-center h-full py-16 text-center gap-5">
                  <div className={`w-14 h-14 flex items-center justify-center rounded-full ${isDark ? "bg-white/5" : "bg-black/5"}`}>
                    <i className={`ri-checkbox-circle-line text-2xl ${isDark ? "text-white/60" : "text-[#555]"}`} />
                  </div>
                  <div>
                    <h3 className={`font-syne text-xl font-semibold mb-2 ${isDark ? "text-white" : "text-[#111]"}`}>
                      Message received!
                    </h3>
                    <p className={`font-inter text-sm leading-relaxed max-w-xs ${isDark ? "text-[#666]" : "text-[#888]"}`}>
                      Thanks for reaching out. We&apos;ll get back to you at <strong className={isDark ? "text-white" : "text-[#111]"}>{email}</strong> within 24 hours.
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() => { setSubmitted(false); setName(""); setEmail(""); setTopic(""); setMessage(""); }}
                    className={`font-inter text-sm font-medium underline underline-offset-2 cursor-pointer transition-colors duration-200 ${isDark ? "text-[#555] hover:text-white" : "text-[#aaa] hover:text-[#111]"}`}
                  >
                    Send another message
                  </button>
                </div>
              ) : (
                <>
                  <h2 className={`font-syne text-xl font-semibold mb-6 ${isDark ? "text-white" : "text-[#111111]"}`}>
                    Send a message
                  </h2>
                  <form
                    data-readdy-form
                    id="contact-us-form"
                    onSubmit={handleSubmit}
                    className="flex flex-col gap-4"
                  >
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="flex flex-col gap-1.5">
                        <label className={`font-inter text-xs font-medium ${isDark ? "text-[#888]" : "text-[#666]"}`}>
                          Your name
                        </label>
                        <input
                          type="text"
                          name="name"
                          required
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          placeholder="Jordan Ellis"
                          className={inputClass}
                        />
                      </div>
                      <div className="flex flex-col gap-1.5">
                        <label className={`font-inter text-xs font-medium ${isDark ? "text-[#888]" : "text-[#666]"}`}>
                          Email address
                        </label>
                        <input
                          type="email"
                          name="email"
                          required
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="you@email.com"
                          className={inputClass}
                        />
                      </div>
                    </div>

                    <div className="flex flex-col gap-1.5">
                      <label className={`font-inter text-xs font-medium ${isDark ? "text-[#888]" : "text-[#666]"}`}>
                        Topic
                      </label>
                      <select
                        name="topic"
                        required
                        value={topic}
                        onChange={(e) => setTopic(e.target.value)}
                        className={`${inputClass} appearance-none cursor-pointer`}
                      >
                        <option value="" disabled className={isDark ? "bg-[#111]" : "bg-white"}>
                          Select a topic…
                        </option>
                        {TOPICS.map((t) => (
                          <option key={t} value={t} className={isDark ? "bg-[#111] text-white" : "bg-white text-[#111]"}>
                            {t}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="flex flex-col gap-1.5">
                      <div className="flex items-center justify-between">
                        <label className={`font-inter text-xs font-medium ${isDark ? "text-[#888]" : "text-[#666]"}`}>
                          Message
                        </label>
                        <span className={`font-inter text-[10px] ${message.length > 500 ? "text-red-400" : isDark ? "text-[#555]" : "text-[#aaa]"}`}>
                          {message.length}/500
                        </span>
                      </div>
                      <textarea
                        name="message"
                        required
                        rows={6}
                        value={message}
                        onChange={(e) => setMessage(e.target.value.slice(0, 500))}
                        placeholder="Tell us what's on your mind…"
                        className={`${inputClass} resize-none`}
                      />
                    </div>

                    {error && (
                      <p className="font-inter text-xs text-red-400 px-1">{error}</p>
                    )}

                    <button
                      type="submit"
                      disabled={submitting || message.length > 500}
                      className={`w-full font-inter font-medium text-sm py-3 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed mt-1 ${isDark ? "bg-white text-black hover:bg-[#e0e0e0]" : "bg-[#111] text-white hover:bg-[#333]"}`}
                    >
                      {submitting ? "Sending…" : "Send Message"}
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
